export default __webpack_public_path__ + "static/media/button_reset.b8ffd96a.mp3";